import React, { FC } from 'react'

import { ProjectCreateContainer, ProjectCreateHelper, StepperNavigation } from 'modules/ProjectCreate/components'
import { helperInfo } from 'modules/ProjectCreate/constants'
import { ArtistAvatar } from 'components'
import { ProductTable } from 'modulesCommon/ProductTable/containers'

import { IProductSelectionProps } from './ProductSelection.props'
import './ProductSelection.scss'

const ProductSelection: FC<IProductSelectionProps> = ({ facebookId, spotifyId, artistName, projectName }) => (
  <>
    <StepperNavigation onNext={() => {}} />
    <ProjectCreateContainer className="product-selection-box">
      <h3 className="product-selection__title">Select your Products</h3>
      <section className="product-selection">
        <div className="product-selection__container">
          <section className="product-selection__artist">
            <ArtistAvatar
              className="product-selection__avatar"
              facebookId={facebookId}
              spotifyId={spotifyId}
              size="s"
              isImage
            />
            <div className="product-selection__info">
              <div className="product-selection__info-container">
                <div>
                  <h6 className="product-selection__info-title">Artist</h6>
                  <p className="product-selection__info-data">{artistName}</p>
                </div>
                <div>
                  <h6 className="product-selection__info-title">Project</h6>
                  <p className="product-selection__info-data">{projectName}</p>
                </div>
              </div>
            </div>
          </section>
        </div>
        <ProjectCreateHelper className="product-selection__helper">
          <p>{helperInfo.createProduct}</p>
        </ProjectCreateHelper>
      </section>

      <ProductTable />
    </ProjectCreateContainer>
  </>
)

export default ProductSelection
